import { AbstractLayer } from './abstract-layer';
import { ContextData } from 'src/app/data/context.data';
import { SVGShapeLayerData } from 'src/app/data/configurator/layer/svg-shape-layer.data';
import { LayerData } from 'src/app/data/configurator/layer/layer.data';
import { CommandData } from 'src/app/data/configurator/command.data';
import { HistoryData } from 'src/app/data/configurator/history.data';
import { environment } from 'src/environments/environment';

declare const fabric: any;

export class SVGLayer extends AbstractLayer {


  /**
   * Contructor
   */
  constructor(data: LayerData, stage: any) {
    super(data, stage);
  }

  /**
   * Draw
   */
  public draw(): Promise<boolean> {
    return new Promise((resolve, reject) => {

      fabric.loadSVGFromString((<SVGShapeLayerData>this._data).svg, (objects, options) => {

        this._display = new fabric.Group(objects);

        this._display.clone((cloned) => {
          this._preview = cloned;

          if (isNaN((<SVGShapeLayerData>this._data).width) && isNaN((<SVGShapeLayerData>this._data).height)) {
            (<SVGShapeLayerData>this._data).x = this._display.left * ContextData.CONVERT_72_TO_DPI;
            (<SVGShapeLayerData>this._data).y = this._display.top * ContextData.CONVERT_72_TO_DPI;
          }

          super._draw();
          resolve(true);

        });


      });
    });
  }

  /**
   * Update data
   */
  updateData(object: any): void {
    let positionData = { x: this.data.x, y: this.data.y, width: this.data.width, height: this.data.height, rotation: this.data.rotation };
    HistoryData.add(this._labelData, this.data, CommandData.SET_POSITION, positionData);

    super.updateData(object);
  }

  /**
   * Update view
   */
  updateView(): void {
    this._display.set({
      fill: (<SVGShapeLayerData>this._data).color
    });

    this._preview.set({
      fill: (<SVGShapeLayerData>this._data).color
    });

    super.updateView();
  }

  /**
   * Cleanup
   */
  public cleanup(): void {

  }
}
